export const GetLoginLinkResponseErrors = {
  COULD_NOT_ACQUIRE_LEASE: "could_not_acquire_lease",
  INVALID_TARGET_GAME: "invalid_target_game",
} as const;
